var e4      = e4 || {},
    wowpark = wowpark || {};
( function () {
    'use strict';
    wowpark.init         = function () {
        wowpark.openingHours.init();
        wowpark.activeCampaign.init();
        wowpark.countdown.init();
    };
    wowpark.countdown         = {
        //requires vendor script
        init: function () {
            e4.util.require.js( e4.settings.require.moment, function () {
                var $clock      = $( '#clock' ),
                    divAttrDate = $( '#clock' ).attr('data-countdownenddate'),
                    eventTime   = moment( divAttrDate, 'DD-MM-YYYY' ).unix(),
                    currentTime = moment().unix(),
                    diffTime    = eventTime - currentTime,
                    duration    = moment.duration( diffTime * 1000, 'milliseconds' ),
                    interval    = 1000;
                //                    console.log(eventTime);
                console.log("new" + divAttrDate);
                // if time to countdown
                if ( diffTime > 0 ) {
                    // Show clock
                    // $clock.show();
                    console.log( $clock );
                    var $y  = $clock.find( '#years' ),
                        $mo = $clock.find( '#months' ),
                        $d  = $clock.find( '#days' ),
                        $h  = $clock.find( '#hours' ),
                        $m  = $clock.find( '#minutes' ),
                        $s  = $clock.find( '#seconds' );
                    setInterval( function () {
                        duration = moment.duration( duration.asMilliseconds() - interval, 'milliseconds' );
                        //                            console.log(moment.duration( duration ).months());
                        //                            console.log(moment.duration( duration ).years());
                        var y  = moment.duration( duration ).years(),
                            mo = moment.duration( duration ).months() + ( y * 12 ),
                            d  = moment.duration( duration ).days(),
                            h  = moment.duration( duration ).hours(),
                            m  = moment.duration( duration ).minutes(),
                            s  = moment.duration( duration ).seconds();
                        y      = $.trim( y ).length === 1 ? '0' + y : y;
                        mo     = $.trim( mo ).length === 1 ? '0' + mo : mo;
                        d      = $.trim( d ).length === 1 ? '0' + d : d;
                        h      = $.trim( h ).length === 1 ? '0' + h : h;
                        m      = $.trim( m ).length === 1 ? '0' + m : m;
                        s      = $.trim( s ).length === 1 ? '0' + s : s;
                        // show how many hours, minutes and seconds are left
                        $y.find( '#years' ).text( y );
                        $mo.find( '#months' ).text( mo );
                        $d.find( '#days' ).text( d );
                        $h.find( '#hours' ).text( h );
                        $m.find( '#minutes' ).text( m );
                        $s.find( '#seconds' ).text( s );
                    }, interval );
                }
            } );
        }
    }
    wowpark.activeCampaign      = {
        init: function () {
            if ( jQuery( '.js-wowpark-activecampaign' ).length > 0 ) {
                wowpark.activeCampaign.styling();
            }
        },
        styling: function () {
            jQuery('.js-wowpark-activecampaign style').remove();
        }
    };
    wowpark.openingHours = {
        settings: {
            dateFormat: 'dd/mm/yyyy'
        },
        init: function () {
            e4.util.require.js( e4.settings.require.datepicker, function () {
                if ( e4.settings.lang === 'da' ) {
                    e4.util.require.js( e4.settings.require.datepicker_da, function () {
                        wowpark.openingHours.requireMoment();
                    });
                }
                if ( e4.settings.lang === 'en' ) {
                    e4.util.require.js( e4.settings.require.datepicker_en, function () {
                        wowpark.openingHours.requireMoment();
                    });
                }
                if ( e4.settings.lang === 'de' ) {
                    e4.util.require.js( e4.settings.require.datepicker_de, function () {
                        wowpark.openingHours.requireMoment();
                    });
                }
            } );
        },
        requireMoment: function(){
            e4.util.require.js( e4.settings.require.moment, function () {
                moment.locale("da");
                wowpark.openingHours.bindDatepicker();
            } );
        },
        bindDatepicker: function () {
            var jDatePicker    = jQuery( '.js-wowpark-opening-hours-datepicker' ),
                objOpeningDays = jQuery( '.js-wowpark-opening-day' ).not( '.js-wowpark-closed-day' ).map( function () {
                    return jQuery( this ).data();
                } ).get(),
                arrEventDays = jQuery( '.js-wowpark-event-day' ).not( '.js-wowpark-closed-day' ).map( function () {
                    return jQuery( this ).data( 'event' );
                } ).get();
            jDatePicker.datepicker( {
                startDate: '0d',
                language: e4.settings.lang,
                beforeShowDay: function ( date ) {
                    var dateFormat = moment( date ).format( "DD-MM-YYYY" ).toLowerCase(),
                    strClasses = 'isCloseDay ',
                    arrDay = objOpeningDays.filter(function ( obj ) {
                       return obj.cleanDate === dateFormat; 
                    });
                    
                    if (arrDay.length > 0 ) {
                        
                        if ( arrDay[0].cleanDate === dateFormat ) {
                            strClasses = 'isOpenDay ';
                        }
                        if ( arrDay[0].event === "True" ) {
                            strClasses += 'isEventDay ';
                        }
                    }
                    
                    return { classes: strClasses };
                }
            } );
            jDatePicker.on( 'changeDate', function ( event ) {
                wowpark.openingHours.showSelectedDate( event );
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Kalender',
                    'eventAction': location.pathname,
                    'eventLabel': event.format( "DD d. MM yyyy" ).toLowerCase(),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        showSelectedDate: function ( objDate ) {
            var jDayElms        = jQuery( '.js-wowpark-opening-day' ),
                jClosedElm      = jDayElms.filter( '.js-wowpark-closed-day' ),
                selectedDateElm = jDayElms.filter( '[data-clean-date="' + objDate.format( "dd-mm-yyyy" ) + '"]' );
            jDayElms.addClass( 'd-none' );
            if ( selectedDateElm.length === 1 ) {
                selectedDateElm.removeClass( 'd-none' );
            }
            else {
                jClosedElm.find( '.js-closed-day-date' ).text( objDate.format( "DD d. MM yyyy" ).toLowerCase() );
                jClosedElm.removeClass( 'd-none' );
            }
        }
    };
}() );
